import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ApiService } from "../services/api";

// KVKK aydınlatma metni (28 Eki): kayıt formunda zorunlu onaylanır; metin ve sürümü sunucudan (kurum adı ayarlardan)
type Metin = { surum: string; kurum: string; bolumler: { baslik: string; metin: string }[] };

export const AydinlatmaIcerik: React.FC = () => {
  const [metin, setMetin] = useState<Metin | null>(null);
  const [hata, setHata] = useState(false);

  useEffect(() => {
    ApiService.getAydinlatmaMetni()
      .then(setMetin)
      .catch(() => setHata(true));
  }, []);

  if (hata) return <p className="text-sm text-red-600">Metin yüklenemedi. Sayfayı yenileyip tekrar deneyin.</p>;
  if (!metin) return <p className="text-sm text-gray-500">Yükleniyor…</p>;
  return (
    <div className="space-y-4 text-sm leading-relaxed text-gray-700">
      {metin.bolumler.map((b) => (
        <section key={b.baslik}>
          <h3 className="font-semibold text-gray-900 mb-1">{b.baslik}</h3>
          <p>{b.metin}</p>
        </section>
      ))}
      <p className="text-xs text-gray-400">Sürüm: {metin.surum}</p>
    </div>
  );
};

/** Kayıt formunda metni sayfadan çıkmadan okutur. */
export const AydinlatmaPenceresi: React.FC<{ acik: boolean; kapat: () => void }> = ({ acik, kapat }) => {
  if (!acik) return null;
  // Gövdeye çizilir: panel içinde (transform'lu <main>) kullanılırsa da ekranın ortasında açılır
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 p-0 sm:p-4" onClick={kapat}>
      <div
        className="bg-white w-full sm:max-w-2xl max-h-[90dvh] flex flex-col rounded-t-2xl sm:rounded-2xl shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="aydinlatma-baslik"
      >
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h2 id="aydinlatma-baslik" className="text-base font-semibold text-gray-900">Kişisel Verilerin Korunması Aydınlatma Metni</h2>
          <button type="button" onClick={kapat} className="text-gray-500 hover:text-gray-800 text-2xl leading-none px-2" aria-label="Kapat">
            ×
          </button>
        </div>
        <div className="overflow-y-auto px-5 py-4">
          <AydinlatmaIcerik />
        </div>
        <div className="px-5 py-3 border-t">
          <button type="button" onClick={kapat} className="w-full py-2.5 rounded-lg bg-purple-600 text-white font-medium hover:bg-purple-700">
            Okudum, kapat
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

/** Herkese açık sayfa (/aydinlatma-metni): WhatsApp mesajından ve sözleşme bağlantılarından açılır. */
const AydinlatmaMetniPage: React.FC = () => (
  <div className="min-h-screen bg-gray-50 py-8 px-4">
    <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border p-6">
      <h1 className="text-xl font-semibold text-gray-900 mb-4">Kişisel Verilerin Korunması Aydınlatma Metni</h1>
      <AydinlatmaIcerik />
    </div>
  </div>
);

export default AydinlatmaMetniPage;
